import NoImage from '../assets/img/user-no-img.png';

//export const baseUrl = "http://localhost:3001";
export const baseUrl = "https://domomail.iosx.in:3001";
export const host = baseUrl + '/api';
export const hostUrl = host + '';
export const filePath = baseUrl + '/uploads';
export const noImage = NoImage;